import { useCallback } from 'react';
import { UrlApi } from '../services/apirest';

//Hook para notificaciones push, ver el backend los endpoints



export function useNotificaciones() {
    const enviarNotificacion = useCallback(async (username, titulo, mensaje, data = {}) => {
        try {
            const token = localStorage.getItem('token'); // lo usamos para validar en el backend 

            const response = await fetch(`${UrlApi}/notificaciones_routes/enviar`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}` // Si usás auth
                },
                body: JSON.stringify({
                    username,
                    titulo,
                    mensaje,
                    data
                })
            });

            if (!response.ok) {
                throw new Error('Error enviando notificación');
            }

            const result = await response.json();
            return result;

        } catch (error) {
            console.error('Error:', error);
            return { enviado: false, error: error.message };
        }
    }, []);

    return { enviarNotificacion };
}